import React, { useState } from 'react';
import { Play, Crosshair } from 'lucide-react';
import { PHONES } from '../../lib/vocalTract/articulations';
import { transcribe } from '../../lib/vocalTract/lexicon';
import { postureFrame } from '../../lib/samuel/phonetic';

const CHIPS = ['p', 'b', 't', 'd', 'k', 'ɡ', 'm', 'n', 'ŋ', 'f', 'v', 'θ', 'ð', 's', 'z', 'ʃ', 'ʒ', 'h', 'tʃ', 'dʒ', 'l', 'r', 'j', 'w',
  'iː', 'ɪ', 'e', 'æ', 'ʌ', 'ɒ', 'ɑː', 'ɔː', 'ʊ', 'uː', 'ə', 'ɜː', 'ɝ', 'ɚ', 'eɪ', 'aɪ', 'ɔɪ', 'aʊ', 'əʊ', 'oʊ', 'ɪə', 'eə', 'ʊə'];

export const PhoneticBuilder = ({ lab, target, words, dialect }) => {
  const [built, setBuilt] = useState([]);
  const posture = () => { const s = PHONES[target]?.s || PHONES[PHONES[target]?.from]?.s; if (s) { lab.stopAll(); lab.eng.pose(postureFrame(s), false); } };
  const say = (phones, label) => { lab.setMode('vf'); lab.fromPhones(phones, label); };
  return (
    <div className="rounded-2xl border border-amber-400/25 bg-slate-900/60 p-4 space-y-3" data-testid="phonetic-builder">
      <p className="text-[10px] uppercase tracking-[0.2em] text-amber-300 font-bold">Articolazione VocalFitness · posture corrette</p>
      {target && (
        <div className="grid grid-cols-2 gap-2">
          <button onClick={() => say(PHONES[target].kind === 's' || PHONES[target].kind === 'a' ? [target, 'ə'] : [target], `/${target}/`)} data-testid="vf-say-target"
            className="py-2.5 rounded-xl bg-amber-400 text-slate-950 font-bold text-sm flex items-center justify-center gap-2"><Play className="w-4 h-4" /> Pronuncia /{target}/</button>
          <button onClick={posture} data-testid="vf-posture-target" className="py-2.5 rounded-xl bg-slate-800 text-cyan-100 font-semibold text-sm flex items-center justify-center gap-2"><Crosshair className="w-4 h-4" /> Mostra la postura</button>
        </div>
      )}
      {!!words.length && (
        <div className="flex flex-wrap gap-1.5">
          {words.map((w) => { const ph = transcribe(w, dialect); return ph && (
            <button key={w} onClick={() => say(ph, w)} data-testid={`vf-word-${w}`} className="px-2.5 py-1.5 rounded-lg bg-cyan-500/10 border border-cyan-400/30 text-left">
              <span className="block text-xs font-bold text-cyan-100">{w}</span><span className="block text-[10px] font-mono text-cyan-300/80">/{ph.join('')}/</span>
            </button>); })}
        </div>
      )}
      <div className="flex flex-wrap gap-1">
        {CHIPS.filter((c) => PHONES[c]).map((c) => (
          <button key={c} onClick={() => setBuilt((b) => [...b, c])} className="min-w-8 h-7 px-1 rounded-md bg-slate-800 hover:bg-slate-700 text-cyan-100 font-mono text-xs" data-testid={`vf-chip-${c}`}>{c}</button>
        ))}
      </div>
      <div className="flex items-center gap-2">
        <span className="flex-1 min-h-[32px] px-3 py-1 rounded-lg bg-slate-950 border border-slate-700 font-mono text-cyan-100 text-sm" data-testid="vf-built">/{built.join('')}/</span>
        <button onClick={() => setBuilt((b) => b.slice(0, -1))} className="px-2 py-1 text-xs rounded bg-slate-800 text-slate-300" data-testid="vf-built-undo">⌫</button>
        <button disabled={!built.length} onClick={() => say(built, `/${built.join('')}/`)} className="px-3 py-1.5 rounded-lg bg-amber-400 text-slate-950 text-xs font-bold disabled:opacity-40" data-testid="vf-built-play">Suona</button>
      </div>
    </div>
  );
};
